const SAMPLE_MS = 15_000;

let capture = null;
let intervalId = null;
let consumers = 0;

function sample() {
  capture?.();
}

export function acquireBookmapSampler(nextCapture) {
  if (!capture) capture = nextCapture;
  consumers += 1;
  sample();
  if (!intervalId) intervalId = window.setInterval(sample, SAMPLE_MS);

  return () => {
    consumers = Math.max(0, consumers - 1);
    if (consumers > 0) return;
    window.clearInterval(intervalId);
    intervalId = null;
    capture = null;
  };
}

export function __resetBookmapSamplerForTests() {
  if (intervalId) window.clearInterval(intervalId);
  capture = null;
  intervalId = null;
  consumers = 0;
}
